import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FeaturedProjectsManager } from "@/components/admin/FeaturedProjectsManager";
import { HomepageFeaturedManager } from "@/components/admin/HomepageFeaturedManager";

const FeaturedContent = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="Featured Content"
        description="Manage featured projects across the site"
      />
      
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold mb-2">Featured Content</h1>
          <p className="text-muted-foreground">
            Configure which projects appear as featured across different pages
          </p>
        </div>

        <Tabs defaultValue="global" className="w-full">
          <TabsList>
            <TabsTrigger value="global">Global Featured</TabsTrigger>
            <TabsTrigger value="homepage">Homepage Featured</TabsTrigger>
          </TabsList>

          <TabsContent value="global" className="mt-6">
            <Card>
              <CardHeader>
                <CardTitle>Global Featured Projects</CardTitle>
                <CardDescription>
                  These projects appear in the main featured section across the site
                </CardDescription>
              </CardHeader>
              <CardContent>
                <FeaturedProjectsManager />
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="homepage" className="mt-6">
            <Card>
              <CardHeader>
                <CardTitle>Homepage Featured Projects</CardTitle>
                <CardDescription>
                  Select up to 3 projects to feature prominently on the homepage
                </CardDescription>
              </CardHeader>
              <CardContent>
                <HomepageFeaturedManager />
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
};

export default FeaturedContent;
